$(document).ready(function(){
  $('.custom-slider').slick({
    autoplay: true, // 自動的にスライドするか
    infinite: true, // スライドをループさせるか
    slidesToShow: 3, // 一度に表示するスライド数
    slidesToScroll: 1, // 1回のスクロールで1枚ずつスライドする
    prevArrow: '<div class="slick-prev"></div>', // 矢印部分PreviewのHTMLを変更
    nextArrow: '<div class="slick-next"></div>', // 矢印部分NextのHTMLを変更
    dots: true, // 下部にドットナビゲーションを表示
    responsive: [
      {
        breakpoint: 769, // モニターの横幅が769px以下の場合
        settings: {
          slidesToShow: 2, // 一度に表示するスライド数を2枚に
          slidesToScroll: 1 // 1回のスクロールで1枚ずつスライドする
        }
      },
      {
        breakpoint: 426, // モニターの横幅が426px以下の場合
        settings: {
          slidesToShow: 1, // 一度に表示するスライド数を1枚に
          slidesToScroll: 1 // 1回のスクロールで1枚ずつスライドする
        }
      }
    ]
  });
});

// $(document).ready(function(){
//     // スライダーの初期化
//     $('.your-slider-class').slick(); 
// });